import styles from 'js/components/pipelines/cards/PipelineOriginCard.module.scss';
import cx from 'classnames';
import Typography from 'new/elements/Typography';
import React from 'react';
import { ReactComponent as ArrowIcon } from 'new/components/icons/arrow.svg';
import { ReactComponent as ArrowRightIcon } from 'new/components/icons/longArrowRight.svg';
import useResourcesCount from 'js/components/pipelines/cards/components/FlowCounters/useResourcesCount';

type FlowCountersProps = {
  isClickablePartHovered: boolean;
  source: any;
  hideArrow?: boolean;
};
export const FlowCounters = (props: FlowCountersProps) => {
  const { isClickablePartHovered, source, hideArrow = false } = props;

  const { childrenCount, sourceDataSetsCount } = useResourcesCount(source);

  const setsLabel = sourceDataSetsCount === 1 ? 'Nexset' : 'Nexsets';
  const derivedDataSetsLabel = `${
    childrenCount.derivedDataSetsCount === 1 ? 'Nexset' : 'Nexsets'
  } Transformed`;

  const sinksLabel = childrenCount.sinksCount === 1 ? 'Destination' : 'Destinations';

  return (
    <div className={cx(styles.counters, isClickablePartHovered && styles.countersHovered)}>
      {!hideArrow && <ArrowIcon className={styles.arrowOpen} />}
      <div>
        <div className={styles.circle} data-nexset-count={sourceDataSetsCount}>
          {sourceDataSetsCount}
        </div>
        <Typography variant="caption" color="primary.dark">
          {setsLabel} Detected
        </Typography>
      </div>
      <ArrowRightIcon />
      <div>
        <div className={styles.circle}>{childrenCount.derivedDataSetsCount}</div>
        <Typography variant="caption" color="primary.dark">
          {derivedDataSetsLabel}
        </Typography>
      </div>
      <ArrowRightIcon />
      <div>
        <div className={styles.circle}>{childrenCount.sinksCount}</div>
        <Typography variant="caption" color="primary.dark">
          {sinksLabel}
        </Typography>
      </div>
    </div>
  );
};
